import type { ReactNode } from 'react'
import { labelStatus, nadaStatus, type NadaBadge } from '@/lib/format'

const KELAS_NADA: Record<NadaBadge, string> = {
  netral: 'bg-netral-100 text-netral-700 border-netral-300',
  sukses: 'bg-yayasan-50 text-yayasan-800 border-yayasan-300',
  peringatan: 'bg-emas-100 text-emas-700 border-emas-300',
  bahaya: 'bg-red-50 text-red-700 border-red-300',
  info: 'bg-blue-50 text-blue-700 border-blue-300',
}

export function Badge({
  children,
  nada = 'netral',
  className = '',
}: {
  children: ReactNode
  nada?: NadaBadge
  className?: string
}) {
  return (
    <span
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium whitespace-nowrap ${KELAS_NADA[nada]} ${className}`}
    >
      {children}
    </span>
  )
}

/** Badge yang menerjemahkan enum backend menjadi label Indonesia + warna. */
export function BadgeStatus({ status, className = '' }: { status: string | null | undefined; className?: string }) {
  return (
    <Badge nada={nadaStatus(status)} className={className}>
      {labelStatus(status)}
    </Badge>
  )
}
